exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scoringPrice[data-v-84c081a6]{font-size:24px;font-weight:700;white-space:nowrap}.accordeon-user-name[data-v-84c081a6]{font-size:18px;font-weight:700}", ""]);

// exports
